export function log() {
    if ((typeof window === 'undefined' ? 'undefined' : typeof(window)) === 'object') {
        if (typeof console !== 'undefined' && typeof console.log === 'function') {
            console.log.apply(console, arguments);
        }
    }
}


